export default function VerdictLegend() {
  return (
    <div className="q-legend">
      <span className="q-legend-item">
        <span className="q-swatch q-swatch--strong" />
        STRONG ≥ 80
      </span>
      <span className="q-legend-item">
        <span className="q-swatch q-swatch--buy" />
        BUY 65–80
      </span>
      <span className="q-legend-item">
        <span className="q-swatch q-swatch--watch" />
        WATCH 50–65
      </span>
      <span className="q-legend-item">
        <span className="q-swatch q-swatch--pass" />
        PASS &lt; 50
      </span>
      <span className="q-legend-item q-legend-item--end">
        <span className="q-swatch q-swatch--na" />
        kein Signal
      </span>
    </div>
  )
}
